// extracted by mini-css-extract-plugin
export var profileSlidingTabsContainer = "styles-module__profileSlidingTabsContainer___KkU1T";
export var slidingTabsScrollButtons = "styles-module__slidingTabsScrollButtons___XFH7b";
export var tabRoot = "styles-module__tabRoot___m02Nl";
export var tabsRoot = "styles-module__tabsRoot___PAUaQ";